export class TheCryptFullScreenDimmer extends PIXI.Container {

    constructor() {
        super();
        this.name = "TheCryptFullScreenDimmer";
    }
    public onResize() {}
}